import { ActionType } from './../constants';

const initialState = {
  login: [],
  loading: false,
  error: null,
  msg: null,
};

const LoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.LOGIN_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionType.LOGIN_FETCH_DATA:
      return {
        ...state,
        loading: false,
        loginInfo: action.payload.loginData,
      };

    case ActionType.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        loginInfo: action.payload.error,
      };

    default:
      return state;
  }
};

export { LoginReducer };
